import React, { useState, useEffect, useCallback } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { change } from "redux-form";
import { SingleDatePicker } from "react-dates";
import { injectIntl } from "react-intl";

import "react-dates/initialize";
import { dateInternationalization, formatLocaleData, isRTL } from "../../../helpers/formatLocale";

import withStyles from "isomorphic-style-loader/withStyles";
import { DatePickerCloseIcon } from "../Assets/SvgIconComponent/CommonSvgIcon";
import cs from "react-dates/lib/css/_datepicker.css";
import t from '../../../styles/reactDatesCalendar.css';
import s from '../../../styles/reactSingleDatesCalendar.css';


const DatePicker = ({
  initialDate,
  formName,
  fieldName,
  placeholder,
  block,
  showClearDate,
  containerClassName
}) => {
  const [focused, setFocused] = useState(false);
  const [date, setDate] = useState(initialDate ? moment(initialDate) : null);
  const [daySize, setDaySize] = useState(
    typeof window !== "undefined" && window.innerWidth <= 350 ? 34 : 42
  );

  const locale = useSelector(state => state.intl.locale);
  const momentLocale = formatLocaleData(locale);
  const dispatch = useDispatch()


  const handleResize = useCallback(() => {
    if (typeof window !== "undefined") {
      setDaySize(window.innerWidth <= 350 ? 34 : 42);
    }
  }, []);


  useEffect(() => {
    if (initialDate) {
      setDate(moment(initialDate));
    }
  }, [initialDate]);


  useEffect(() => {
    dateInternationalization(locale);
    moment.locale(momentLocale);
    setDate((currentDate) => currentDate ? moment(currentDate).locale(momentLocale) : currentDate);
  }, [locale, momentLocale]);


  useEffect(() => {
    handleResize();
    if (typeof window !== "undefined") {
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, [handleResize]);

  const onDateChange = (newDate) => {
    if (formName && fieldName) {
      dispatch(change(formName, fieldName, newDate));
    }
    setDate(newDate);
  };

  const onFocusChange = ({ focused }) => {
    setFocused(focused);
  };

  return (
    <div className={containerClassName}>
      <SingleDatePicker
        displayFormat={'L'}
        key={`${locale}-${daySize}`}
        onDateChange={onDateChange}
        onFocusChange={onFocusChange}
        focused={focused}
        date={date}
        placeholder={placeholder}
        readOnly
        daySize={daySize}
        id="DatePickerId"
        numberOfMonths={1}
        hideKeyboardShortcutsPanel
        showClearDate={showClearDate}
        anchorDirection={isRTL(locale) ? "right" : "left"}
        isRTL={isRTL(locale)}
        block={block}
        customCloseIcon={<DatePickerCloseIcon className='adminCalenderCustomCloseIcon' />}
        transitionDuration={0}
      />
    </div>
  );
};

export default injectIntl(
  withStyles(cs, s, t)(DatePicker)
);
